import { render, staticRenderFns } from "./AnnouncementListItem.vue?vue&type=template&id=e4fef2e4&scoped=true&"
import script from "./AnnouncementListItem.vue?vue&type=script&lang=js&"
export * from "./AnnouncementListItem.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementListItem.vue?vue&type=style&index=0&id=e4fef2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fef2e4",
  null
  
)

export default component.exports